import { render, staticRenderFns } from "./ViewPublicJobDetails.vue?vue&type=template&id=d08a06e2&scoped=true&"
import script from "./ViewPublicJobDetails.vue?vue&type=script&lang=ts&"
export * from "./ViewPublicJobDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ViewPublicJobDetails.vue?vue&type=style&index=0&id=d08a06e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08a06e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VMain,VRow})
